import Cookies from 'cookies-js';
import { sources } from '@mysidewalk/active-record';
class SessionManagerRecordSource extends sources.ActiveRecordJSONAPISource {
    transformRequest(request) {
        request.credentials = 'include';
        return request;
    }
    transformRequestHeaders(custom = {}) {
        const combined = { ...custom };
        if (Cookies.enabled) {
            combined['X-CSRFTOKEN'] = Cookies.get('csrftoken');
        }
        return super.transformRequestHeaders(combined);
    }
}
SessionManagerRecordSource.defaults = {
    headers: {
        'Content-Type': 'application/json',
    },
};
export default SessionManagerRecordSource;
